import React from 'react';
import { Box, Typography } from '@mui/material';
import Card from 'components/Card/Card';
import SkeletonCardList from 'components/Skeletons/CardSkeleton/SkeletonCardList/SkeletonCardList';
import { useGetAllDebatesQuery } from 'redux/api/debate.api';
import { IDebateData } from 'shared/types/debates.interface';
import { ECardTypes } from 'shared/types/card.interface';
import { PAGE_PLACEHOLDERS_DATA } from 'shared/constants/no-content-constants';
import { CardsContainer } from 'components/Card/CardsContainer/CardsContainer';
import { PageContainer } from 'pages/PageContainer';

const DebatesFeed: React.FunctionComponent<any> = () => {
  const { data: allDebates = [], isLoading } = useGetAllDebatesQuery(undefined, {
    pollingInterval: 1000,
    refetchOnMountOrArgChange: true,
  });

  return (
    <PageContainer>
      <CardsContainer>
        {isLoading ? (
          <SkeletonCardList />
        ) : allDebates.length ? (
          allDebates?.map((debate: IDebateData) => (
            <Card
              cardInfo={debate.challenge}
              key={debate.id}
              type={ECardTypes.Debate}
              debate={debate}
            />
          ))
        ) : (
          <Box sx={{ width: '100%', textAlign: 'center' }}>
            <Typography variant="body1" color="primary.main">
              {PAGE_PLACEHOLDERS_DATA.debatesFeed}
            </Typography>
          </Box>
        )}
      </CardsContainer>
    </PageContainer>
  );
};

export default DebatesFeed;
